import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

interface TrendData {
  date: string;
  bookings: number;
  revenue?: number;
  occupancyRate: number;
}

interface TrendChartProps {
  data: TrendData[];
  title: string;
  showRevenue?: boolean;
}

export default function TrendChart({ data, title, showRevenue = false }: TrendChartProps) {
  const formatDate = (dateStr: string) => {
    return format(new Date(dateStr), 'MMM yyyy', { locale: fr });
  };

  const formatValue = (value: number) => {
    if (showRevenue) {
      return `${value.toLocaleString('fr-FR')} €`;
    }
    return value.toFixed(1);
  };

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h3 className="text-lg font-semibold mb-4">{title}</h3>
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="date" 
              tickFormatter={formatDate}
              interval="preserveStartEnd"
            />
            <YAxis yAxisId="left" />
            {showRevenue && <YAxis yAxisId="right" orientation="right" />}
            <Tooltip 
              formatter={formatValue}
              labelFormatter={formatDate}
            />
            <Legend />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="bookings"
              name="Réservations"
              stroke="#2563eb"
              activeDot={{ r: 8 }}
            />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="occupancyRate"
              name="Taux d'occupation (%)"
              stroke="#16a34a"
              activeDot={{ r: 8 }}
            />
            {showRevenue && (
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="revenue"
                name="Revenus (€)"
                stroke="#9333ea"
                activeDot={{ r: 8 }}
              />
            )}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}